export const mergeResponse = (input) => {
  return input?.reduce((acc, current) => {
    const existing = acc.find((item) => item.requestId === current.requestId);
    const currentPairs = Array.isArray(current.servicesProvided)
      ? current.servicesProvided.map((service, index) => ({
          service,
          country: Array.isArray(current.serviceCountries)
            ? current.serviceCountries[index]
            : current.serviceCountries
        }))
      : [{
          service: current.servicesProvided,
          country: current.serviceCountries
        }];
 
    if (existing) {
      const allPairs = [...existing._serviceCountryPairs, ...currentPairs];
      const seen = new Set();
      const uniquePairs = [];

      for (const pair of allPairs) {
        const key = `${pair.service}|${pair.country}`;
        if (!seen.has(key)) {
          seen.add(key);
          uniquePairs.push(pair);
        }
      }
      existing._serviceCountryPairs = uniquePairs;
    } else {
      acc.push({
        ...current,
        _serviceCountryPairs: currentPairs,
      });
    }
    return acc;
  }, []).map(item => {
    const services = item._serviceCountryPairs.map(p => p.service);
    const countries = item._serviceCountryPairs.map(p => p.country);
    const { _serviceCountryPairs, ...rest } = item;
    return {
      ...rest,
      servicesProvided: services.length === 1 ? services[0] : services,
      serviceCountries: countries.length === 1 ? countries[0] : countries,
    };
  });
};
